// 副菜单锚点滚动
export function anchorTo(data) {
  let anchor = document.getElementById(data.id)
  let offset = anchor.offsetTop - 180
  let distance = document.documentElement.scrollTop
  let step = offset / 50
  if (offset >= distance) {
    smoothDowm()
  } else {
    let newOffset = distance - offset
    step = newOffset / 50
    smoothUp()
  }
  // document.documentElement.scrollTop = offset
  function smoothDowm() {
    if (distance < offset) {
      distance += step
      document.documentElement.scrollTop = distance
      setTimeout(() => {
        smoothDowm()
      }, 10);
    } else {
      document.documentElement.scrollTop = offset
    }
  }
  function smoothUp() {
    if (distance > offset) {
      distance -= step
      document.documentElement.scrollTop = distance
      setTimeout(() => {
        smoothUp()
      }, 10);
    } else {
      document.documentElement.scrollTop = offset
    }
  }
}
// 初始化图表
export function initChart(id, options) {
  let chart = echarts.init(document.getElementById(id));
  chart.setOption(options);
}

export const formatTime = (date, out = 'd') => {
  if (!date) return ``
  const temp = new Date(date)
  const year = temp.getFullYear(),
    mouth = (temp.getMonth() + 1) > 9 ? (temp.getMonth() + 1) : '0' + (temp.getMonth() + 1),
    day = temp.getDate() > 9 ? temp.getDate() : '0' + temp.getDate(),
    h = temp.getHours() > 9 ? temp.getHours() : '0' + temp.getHours(),
    m = temp.getMinutes() > 9 ? temp.getMinutes() : '0' + temp.getMinutes(),
    s = temp.getSeconds() > 9 ? temp.getSeconds() : '0' + temp.getSeconds()
  let res = ``

  switch (out) {
    case 'y':
      res = year
      break;
    case 'm':
      res = `${year}-${mouth}`
      break;
    case 'd':
      res = `${year}-${mouth}-${day}`
      break;
    case 'hh':
      res = `${year}-${mouth}-${day} ${h}`
      break;
    case 'mm':
      res = `${year}-${mouth}-${day} ${h}:${m}`
      break;
    case 'ss':
      res = `${year}-${mouth}-${day} ${h}:${m}:${s}`
      break;
  }
  return res
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.js